package com.parmartechnologies.core.feature.employee.model

import com.parmartechnologies.core.extension.BaseDataClass
import com.parmartechnologies.core.feature.address.model.Address
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.ExperimentalTime

@Serializable
data class Employee @OptIn(ExperimentalTime::class) constructor(
    @SerialName("user_id") var UserID: String = "",
    @SerialName("employee_user_id") var EmployeeUserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    @SerialName("name") var Name: String = "",
    @SerialName("address") var Address: Address? = null,
    @SerialName("gst_number") var GSTNumber: String = "",
    @SerialName("bar_code") var Barcode: String = "",
    @SerialName("status") var Status: String = "",
    @SerialName("email_id") var EmailID: String = "",
    @SerialName("mobile_number") var MobileNumber: String = "",
    @SerialName("whatsapp") var WhatsApp: String = "",
    @SerialName("dial_code") var DialCode: String = "",
    @SerialName("gender") var Gender: Long = 0,
    @SerialName("device_id") var DeviceID: String = "",
    @SerialName("fcm_token") var FCMToken: String = "",
    @SerialName("total_sale") var TotalSale: Long = 0,
    @SerialName("total_payment") var TotalPayment: Long = 0,
    @SerialName("last_seen") var LastSeen: String = "",
    @SerialName("job_type_id") var JobTypeId: String = "",
    @SerialName("job_type_name") var JobTypeName: String = "",
): BaseDataClass()
